import { Icon, type IconTypes } from '@procurify/ui'

import { ExpenseTypeLabelStyled } from './styles/ExpenseTypeLabelStyled'
import {
  ExpenseTypes,
  type ExpenseTypeEnum,
} from '../../entities/enums/ExpenseTypeEnum'
import { useFormatExpenseItemTypeLabel } from '../../hooks/useFormatExpenseItemTypeLabel'

const EXPENSE_TYPE_ICON_MAP: Record<ExpenseTypeEnum, IconTypes> = {
  [ExpenseTypes.OTHER]: 'other',
  [ExpenseTypes.MEALS]: 'meals',
  [ExpenseTypes.MILEAGE]: 'mileage',
  [ExpenseTypes.LABOUR]: 'labour',
  [ExpenseTypes.AIRFARE]: 'flight',
  [ExpenseTypes.LODGING]: 'lodge',
}

export interface IExpenseTypeLabelProps {
  type: ExpenseTypeEnum
}

export const ExpenseTypeLabel = ({ type }: IExpenseTypeLabelProps) => {
  const formatExpenseItemTypeLabel = useFormatExpenseItemTypeLabel()
  const icon = EXPENSE_TYPE_ICON_MAP[type]
  const label = formatExpenseItemTypeLabel(type)

  return (
    <ExpenseTypeLabelStyled>
      <Icon icon={icon} size={14} color='darkGrey' />
      {label}
    </ExpenseTypeLabelStyled>
  )
}
